import React, { PureComponent } from 'react'
// import { Grid } from 'react-bootstrap'

class Access extends PureComponent {
  render () {
    return (
      <div className="_nf bg-auth">

        {this.props.children}

      </div>
    )
  }
}
export default Access
